/**
 * NOTE: This file is ignored from git tracking. In a CI environment it is
 * generated by firebase-ci or build/create-config.js based on config in
 * .firebaserc (see .travis.yml). This is done so that environment specific
 * settings can be applied.
 */

export const env = 'development'

// Prod config for firebase
export const firebase = {
  apiKey: 'AIzaSyDYtraCPphzrDJ2zchy33Cug2tyEkqchcg',
  authDomain: 'siouxneil-dumo.firebaseapp.com',
  databaseURL: 'https://siouxneil-dumo.firebaseio.com',
  projectId: 'siouxneil-dumo',
  storageBucket: 'siouxneil-dumo.appspot.com',
}

// Dev config for firebase
// export const firebase = {
//   apiKey: 'AIzaSyBrGrFhUs5EXMwIGrBVAg0wDKrbBhUdLKI',
//   authDomain: 'siouxneil-dumo-dev.firebaseapp.com',
//   databaseURL: 'https://siouxneil-dumo-dev.firebaseio.com',
//   projectId: 'siouxneil-dumo-dev',
//   storageBucket: 'siouxneil-dumo-dev.appspot.com',
// }

// Config for react-redux-firebase
// For more details, visit http://react-redux-firebase.com/docs/api/enhancer.html
export const reduxFirebase = {
  userProfile: 'users', // root that user profiles are written to
  enableLogging: false, // enable/disable Firebase Database Logging
  // updateProfileOnLogin: false // enable/disable updating of profile on login
  // profileDecorator: (userData) => ({ email: userData.email }) // customize format of user profile
}

export default { env, firebase, reduxFirebase }



// WEBPACK FOOTER //
// ./src/config.js